import React, { useState, useEffect, useContext } from 'react';

import * as utils from "../../../assets/utils";
import * as net from "../../../lib/net";

import Tr_Add from "./fkn/tr_add";
import Tr_Open from "./fkn/tr_open";
import {toMProc} from "../../../assets/utils";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Trs extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";

    this.state.tra = [];
    this.state.trs = [];
    this.state.pka = [];
    this.state.pta = [];

    this.state.tro = {};
    this.state.pko = {};
    this.state.aa = [];
    this.state.cols = {};
    this.state.wnds = {};
    this.state.typ = "";
    this.state.sz_val = "";
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.trs();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 225;
      css.overflow = "auto";
      return css;
  }
  tab_style(typ) {
      var css = {};
      if(this.state.typ == typ) { css.background = "#009900"; css.color = "#fff"; }
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  th_style(id) {
      var css = {};
      css.cursor = "pointer";
      if(id == this.state.sortid) css.color = "#080";
      return css;
  }

  tr_add() {
    var self = this;
    var wnds = {};
    wnds.tradd = true;
    this.setState({ wnds: wnds });
  }
  tr_edit(row) {
    var self = this;
    var wnds = {};
    wnds.tropen = true;
    wnds.tro = row;
    this.setState({ wnds: wnds });
  }
  tr_close(ctx) {
    ctx.setState({ wnd_tr: false });
    ctx.trs();
  }
  pkat_add(row) {
    var self = this;
    var wnds = {};
    wnds.pkatopen = true;
    wnds.pko = null;
    this.setState({ wnds: wnds });
  }
  pkat_edit(row) {
    var self = this;
    var wnds = {};
    wnds.pkatopen = true;
    wnds.pko = row;
    this.setState({ wnds: wnds });
  }
  pkat_close(ctx) {
    ctx.setState({ wnd_pkat: false });
    ctx.pkat();
  }
  pay_edit(row) {
    var self = this;
    var wnds = {};
    wnds.payopen = true;
    wnds.tro = row;
    this.setState({ wnds: wnds });
  }

  trs() {
    var self = this;
    self.setState({typ: "trs", tra: [], pka: [], pta: [] });

    var prm = {};
    prm.req = "pms.tr.qs_trs";
    prm.typ = "T";

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ trs: ret.rca, tra: ret.rca }, function() {
            self.syncTb("traTable");
        });
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  pkat() {
    var self = this;
    self.setState({typ: "pkat", tra: [], pka: [], pta: [] });

    var prm = {};
    prm.req = "pms.pkat.qa_pkats";
    prm.typ = "P";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({pka: ret.rca });
        self.syncTb("pkaTable");
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  pay() {
    var self = this;
    self.setState({typ: "pay", tra: [], pka: [], pta: [] });

    var prm = {};
    prm.req = "pms.tr.qs_pays";
    prm.typ = "B";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({pta: ret.rca });
        self.syncTb("ptaTable");
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var tra = self.state.tra;
      var sz = this.state.sz_val;

      tra.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
      self.setState({ tra: tra, sortid: typ });
   }

   tb_filtr() {
    var self = this;
    var trs = self.state.trs;
    var sz = this.state.sz_val;

    if(sz.length < 1) {
      self.setState({ tra: trs });
        return;
    }
    sz = sz.toUpperCase();
    var tra = trs.filter(function(row) {
          var brc = false;
          if(row.e1typ.toUpperCase().includes(sz)) brc = true;
          if(row.e1kontonr.toUpperCase().includes(sz)) brc = true;
          if(row.e1text.toUpperCase().includes(sz)) brc = true;
          return brc;
    });
    self.setState({tra: tra });
 }
  sz_style() {
        var css = {};
        css.height = "40px";
        css.lineHeight = "40px";
        css.padding = "0px 10px";
        css.fontSize = "12px";
        css.cursor = "pointer";
        return css;
    }

    sz_keydown (e) {
    //e.preventDefault();
      const key = e.key;
      const keyCode = e.keyCode;

      if(keyCode == 13) {
          this.tb_filtr();
      };
      if(keyCode == 27) {
          this.setState({sz_val: ""});
      };
  }
  sz_change (e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({sz_val: value});
      //setState({[name]: value});
  }

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <input className="txt sztxt" value={this.state.sz_val} placeholder="Ange söktext..."  style={ this.sz_style() } onChange={(e) => this.sz_change(e)} onKeyDown={(e) => this.sz_keydown(e)} />

        <div className="flex-row"></div>

        <div className="flex-row flex-end flex">
        <button className="btn btn-hw-orange w150" onClick={() => this.tr_add() } aria-label="System" >
            LÄGG TILL
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.trs() } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

        <div id="traTable" className="flex">
          <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.th_style("e1typ") } onClick={() => this.tb_sort("e1typ") }>Id</th>
                <th style={ this.th_style("e1kontonr") } onClick={() => this.tb_sort("e1kontonr") }>Konto</th>
                <th style={ this.th_style("e1text") } onClick={() => this.tb_sort("e1text") }>Text</th>
                <th style={ this.th_style("e1debcre") } onClick={() => this.tb_sort("e1debcre") }>Debet</th>
                <th style={ this.th_style("e1moms") } onClick={() => this.tb_sort("e1moms") }>Moms</th>
                <th style={ this.th_style("e1pris") } onClick={() => this.tb_sort("e1pris") }>Pris</th>
                <th style={ this.th_style("e1mattyp") } onClick={() => this.tb_sort("e1mattyp") }>Mattyp</th>
                <th style={ this.th_style("e1kassabal") } onClick={() => this.tb_sort("e1kassabal") }>Kassabal</th>
                <th style={ this.th_style("e1paytrans") } onClick={() => this.tb_sort("e1paytrans") }>Betaltrans</th>
                <th style={ this.th_style("e1man_rep") } onClick={() => this.tb_sort("e1man_rep") }>Rapport</th>
                <th></th>
            </tr>
            </thead>
        </table>
        <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover tb">
            <tbody>
            { this.state.tra.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.tr_edit(row) }>
                <td className="text-center">{ row.e1typ }</td>
                <td>{ row.e1kontonr }</td>
                <td>{ utils.toLang( row.e1text.trim() ) }</td>
                <td>{ row.e1debcre }</td>
                <td className="text-center">{ utils.toMProc( row.e1moms ) }</td>
                <td className="txt_right">{ utils.toPris( row.e1pris ) }</td>
                <td>{ row.e1mattyp }</td>
                <td>{ row.e1kassabal }</td>
                <td>{ row.e1paytrans }</td>
                <td>{ row.e1man_rep }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.tr_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
    </div>
        { this.state.wnds.tradd ? <Tr_Add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.tropen ? <Tr_Open wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }

   </div>
  );
    }
}
export default Reg_Trs;
/*

*/